export default "__VITE_ASSET__wEXMYNr8__"